import styled from 'styled-components/macro';
import { Button } from 'components/ui';

export const DeleteButton = styled.div`
  position: absolute;
  z-index: 999;
  top: -18px;
  right: -18px;
  display: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: #000000;
  cursor: pointer;

  &:hover {
    color: red;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: fit-content;

  &:hover ${DeleteButton} {
    display: inline-flex;
  }
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  cursor: pointer;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  z-index: 999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DndFileWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const Loader = styled.div`
  position: absolute;
  z-index: 5;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DndDeleteButton = styled(Button)`
  position: absolute;
  z-index: 10;
  top: 6px;
  right: 6px;
  max-width: 24px;
  max-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;
